import { render } from "./XIconSolidSchool.vue?vue&type=template&id=e9163afc"
import script from "./XIconSolidSchool.vue?vue&type=script&lang=js"
export * from "./XIconSolidSchool.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidSchool.vue"]])

export default __exports__